import { IInserirEnvelopeBody } from "../../../Interfaces/Geral/Envelopes/EnvelopesInterface";
import { InserirEnvelopeServices, ListarConfigEnvelopeServices } from "../../../Services/Geral/Envelopes/EnvelopesServices";
import { Controller } from "../../Controller";

export function InserirEnvelopeController(requestBody: IInserirEnvelopeBody) {
    return (
        Controller(
            InserirEnvelopeServices(requestBody)
        )
    )
}

export function ListarConfigEnvelopeController(idDocusignEnvelopeConfig: number) {
    return (
        Controller(
            ListarConfigEnvelopeServices(idDocusignEnvelopeConfig)
        )
    )
}

